<form-workflow
  [form]="rsf"
  [sectionNumber]="5"
  [service]="service"
  [disabled]="disabled || !rsf?.workerVerificationSigned"
  [overrideDisabledStep]="overrideShieldingWorkCompleteDisabled"
></form-workflow>
